import { render, staticRenderFns } from "./TeacherVerify5.vue?vue&type=template&id=83c45786&"
import script from "./TeacherVerify5.vue?vue&type=script&lang=js&"
export * from "./TeacherVerify5.vue?vue&type=script&lang=js&"
import style0 from "./TeacherVerify5.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports